import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import BaseModal from 'components/Modals/BaseModal';
import Button from 'components/Button';
import './UploadFolderModal.sass';

function UploadFolderModal({ isLoading, isOpen, onClose, onUpload, type }) {
  const handleUpload = (event) => {
    event.preventDefault();
    onUpload();
  };

  return (
    <BaseModal
      isOpen={isOpen}
      headerTitle={
        type === 'icon'
          ? 'upload-folder-modal.header-icon'
          : 'upload-folder-modal.header'
      }
      maxWidth="500px"
      onClose={onClose}>
      <form className="upload-folder-modal__form" onSubmit={handleUpload}>
        <p className="upload-folder-modal__message">
          <FormattedMessage
            id={
              type === 'icon'
                ? 'upload-folder-modal.message-icon'
                : 'upload-folder-modal.message'
            }
          />
        </p>
        <div className="upload-folder-modal__actions">
          <Button
            type="button"
            variant="outlined"
            onClick={onClose}
            disabled={isLoading}>
            <FormattedMessage id="upload-folder-modal.cancel" />
          </Button>
          <Button
            type="submit"
            variant="contained"
            loading={isLoading}
            disabled={isLoading}>
            <FormattedMessage id="upload-folder-modal.upload" />
          </Button>
        </div>
      </form>
    </BaseModal>
  );
}

UploadFolderModal.propTypes = {
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['image', 'icon']),
};

UploadFolderModal.defaultProps = {
  type: 'image',
};

export default UploadFolderModal;
